import { render, staticRenderFns } from "./FileUploadForm.vue?vue&type=template&id=80c7ca04&lang=pug"
import script from "./FileUploadForm.vue?vue&type=script&lang=js"
export * from "./FileUploadForm.vue?vue&type=script&lang=js"
import style0 from "./FileUploadForm.vue?vue&type=style&index=0&id=80c7ca04&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports